var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.344,
    height: 131.503,
    viewBox: "0 0 100.344 131.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3316",
    "data-name": "Group 3316",
    transform: "translate(-142.429 -338.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(166.611 338.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(0 18.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M28.417,80.025V66.991a14.5,14.5,0,0,0-1.311-6.2c-1.313-2.782-3.711-5.511-8.062-5.511A9.561,9.561,0,0,0,9.7,64.827V96.674a5.073,5.073,0,0,1-4.73,5.063A4.84,4.84,0,0,1,.016,96.9V71.313c0-6-.411-11.581,2.963-16.876A19.015,19.015,0,0,1,19.057,45.6a17.967,17.967,0,0,1,12.879,5.28,22.424,22.424,0,0,1,6.14,14.144c.144,2.358.036,4.746.036,7.108v7.893a4.847,4.847,0,1,1-9.694,0",
    transform: "translate(0 -45.6)",
    fill: "#0079fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(27.31 41.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M82.665,136.721a19.587,19.587,0,0,1-15.274-7.292,5.656,5.656,0,0,1-1.2-4.468,5.541,5.541,0,0,1,2.5-3.783l.488-.311a5.615,5.615,0,0,1,7.392,1.306,7.833,7.833,0,0,0,5.693,2.9,8.032,8.032,0,0,0,8.432-8.02V105.4a5.83,5.83,0,0,1,6.086-5.812,6.043,6.043,0,0,1,5.562,6.12v13.7H102.2a19.724,19.724,0,0,1-19.531,17.315M72.1,122.21a3.254,3.254,0,0,0-1.747.509l-.488.31a3.306,3.306,0,0,0-1.506,2.283,3.463,3.463,0,0,0,.734,2.734,17.467,17.467,0,0,0,31.006-9.813l.046-.674V105.707a3.83,3.83,0,0,0-3.462-3.927,3.647,3.647,0,0,0-2.678,1.009,3.585,3.585,0,0,0-1.118,2.611v11.656a10.16,10.16,0,0,1-18.013,6.515A3.616,3.616,0,0,0,72.1,122.21",
    transform: "translate(-66.121 -99.58)",
    fill: "#0079fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(11.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M36.087,16.83a8.415,8.415,0,1,0-8.415-8.415,8.415,8.415,0,0,0,8.415,8.415",
    transform: "translate(-27.672)",
    fill: "#0079fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(48.874 22.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M126.747,70.807a8.415,8.415,0,1,1,8.415-8.415,8.425,8.425,0,0,1-8.415,8.415m0-14.769a6.354,6.354,0,1,0,6.355,6.354,6.362,6.362,0,0,0-6.355-6.354",
    transform: "translate(-118.332 -53.977)",
    fill: "#0079fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(144.03 436.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M222.6,69.087V90.833h-4.132l-10.842-13.2v13.2h-4.97V69.087h4.163l10.811,13.2v-13.2Z",
    transform: "translate(-202.658 -69.087)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M284.326,92.109H271.682a3.935,3.935,0,0,0,1.615,2.454,5.346,5.346,0,0,0,3.169.9,6.4,6.4,0,0,0,2.314-.389,5.6,5.6,0,0,0,1.88-1.227l2.578,2.8q-2.361,2.7-6.9,2.7a10.907,10.907,0,0,1-5-1.1,8.078,8.078,0,0,1-3.355-3.06,8.425,8.425,0,0,1-1.181-4.443,8.544,8.544,0,0,1,1.165-4.427,8.159,8.159,0,0,1,3.2-3.075,9.906,9.906,0,0,1,8.994-.047,7.717,7.717,0,0,1,3.122,3.029,9.031,9.031,0,0,1,1.134,4.582Q284.419,90.9,284.326,92.109Zm-11.339-5.374a3.969,3.969,0,0,0-1.367,2.547h8.233a4.008,4.008,0,0,0-1.367-2.531,4.086,4.086,0,0,0-2.734-.948A4.175,4.175,0,0,0,272.987,86.735Z",
    transform: "translate(-243.288 -77.353)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M333.306,83.985a7.074,7.074,0,0,1,2.082,5.576V99.1h-4.536V97.018q-1.368,2.329-5.095,2.33a7.909,7.909,0,0,1-3.34-.653,4.98,4.98,0,0,1-2.159-1.8,4.69,4.69,0,0,1-.745-2.61,4.355,4.355,0,0,1,1.755-3.666q1.755-1.335,5.421-1.336h3.852a3.089,3.089,0,0,0-.963-2.438,4.242,4.242,0,0,0-2.889-.854,8.427,8.427,0,0,0-2.625.419,6.949,6.949,0,0,0-2.19,1.134l-1.74-3.386a10.5,10.5,0,0,1,3.278-1.491,14.686,14.686,0,0,1,3.93-.528A8.7,8.7,0,0,1,333.306,83.985Zm-4.132,11.525a3.146,3.146,0,0,0,1.367-1.693V92.109h-3.324q-2.982,0-2.982,1.957a1.742,1.742,0,0,0,.73,1.475,3.286,3.286,0,0,0,2,.544A4.215,4.215,0,0,0,329.174,95.511Z",
    transform: "translate(-276.673 -77.353)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M381.735,82.758a8.714,8.714,0,0,1,3.4-.621V86.61q-.808-.062-1.088-.062a4.441,4.441,0,0,0-3.262,1.165,4.707,4.707,0,0,0-1.18,3.495V99.1h-4.846V82.385h4.629v2.206A5.393,5.393,0,0,1,381.735,82.758Z",
    transform: "translate(-311.666 -77.353)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M413.539,88.628q-2.594-2.579-2.594-7.363V69.087h5.032V81.078q0,5.841,4.846,5.84a4.544,4.544,0,0,0,3.6-1.413,6.591,6.591,0,0,0,1.242-4.427V69.087h4.97V81.265q0,4.784-2.594,7.363a11.493,11.493,0,0,1-14.508,0Z",
    transform: "translate(-334.585 -69.087)",
    fill: "#0079fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(142.429 463.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M202.824,143.05a2.275,2.275,0,0,1,0,3.332,3.018,3.018,0,0,1-1.992.6h-1.611v1.973h-.931v-6.516h2.541A3.018,3.018,0,0,1,202.824,143.05Zm-.67,2.75a1.5,1.5,0,0,0,0-2.169,2.1,2.1,0,0,0-1.349-.377h-1.583v2.923H200.8A2.1,2.1,0,0,0,202.154,145.8Z",
    transform: "translate(-198.291 -142.054)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M217.813,146.858a2.5,2.5,0,0,1,1.108-.223v.866a1.656,1.656,0,0,0-.2-.01,1.5,1.5,0,0,0-1.141.433,1.715,1.715,0,0,0-.414,1.233v2.458h-.893v-4.933h.856v.829A1.526,1.526,0,0,1,217.813,146.858Z",
    transform: "translate(-209.677 -144.708)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M226.681,151.345a2.361,2.361,0,0,1-.917-.9,2.718,2.718,0,0,1,0-2.6,2.333,2.333,0,0,1,.917-.894,2.874,2.874,0,0,1,2.639,0,2.341,2.341,0,0,1,.912.894,2.718,2.718,0,0,1,0,2.6,2.37,2.37,0,0,1-.912.9,2.831,2.831,0,0,1-2.639,0Zm2.173-.675a1.544,1.544,0,0,0,.591-.614,2.033,2.033,0,0,0,0-1.815,1.514,1.514,0,0,0-.591-.61,1.8,1.8,0,0,0-1.7,0,1.543,1.543,0,0,0-.6.61,1.991,1.991,0,0,0,0,1.815,1.574,1.574,0,0,0,.6.614,1.77,1.77,0,0,0,1.7,0Z",
    transform: "translate(-215.482 -144.708)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M244.351,149.542a1.338,1.338,0,0,1-.484.256,2.031,2.031,0,0,1-.6.089,1.579,1.579,0,0,1-1.154-.4,1.528,1.528,0,0,1-.41-1.145v-2.709h-.838V144.9h.838v-1.08h.893v1.08h1.415v.735H242.6V148.3a.866.866,0,0,0,.2.614.745.745,0,0,0,.573.214,1.075,1.075,0,0,0,.7-.233Z",
    transform: "translate(-225.26 -142.923)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M256.963,149.446h-4a1.552,1.552,0,0,0,.572,1.048,1.872,1.872,0,0,0,1.215.4,1.83,1.83,0,0,0,1.424-.6l.493.577a2.149,2.149,0,0,1-.833.6,3.138,3.138,0,0,1-2.5-.116,2.291,2.291,0,0,1-.936-.9,2.577,2.577,0,0,1-.331-1.3,2.616,2.616,0,0,1,.321-1.294,2.307,2.307,0,0,1,.885-.9,2.518,2.518,0,0,1,1.27-.321,2.469,2.469,0,0,1,1.262.321,2.261,2.261,0,0,1,.866.9,2.739,2.739,0,0,1,.312,1.322A2.542,2.542,0,0,1,256.963,149.446Zm-3.5-1.666a1.574,1.574,0,0,0-.507,1.024h3.165a1.589,1.589,0,0,0-.507-1.019,1.666,1.666,0,0,0-2.15,0Z",
    transform: "translate(-232.352 -144.708)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M268.868,151.345a2.387,2.387,0,0,1-.926-.9,2.684,2.684,0,0,1,0-2.6,2.359,2.359,0,0,1,.926-.894,2.772,2.772,0,0,1,1.345-.321,2.584,2.584,0,0,1,1.2.269,1.924,1.924,0,0,1,.815.782l-.679.437a1.517,1.517,0,0,0-.577-.53,1.646,1.646,0,0,0-.763-.177,1.764,1.764,0,0,0-.87.214,1.526,1.526,0,0,0-.605.61,2.01,2.01,0,0,0,0,1.824,1.523,1.523,0,0,0,.605.61,1.765,1.765,0,0,0,.87.214,1.646,1.646,0,0,0,.763-.177,1.516,1.516,0,0,0,.577-.53l.679.428a1.949,1.949,0,0,1-.815.787,2.541,2.541,0,0,1-1.2.275A2.738,2.738,0,0,1,268.868,151.345Z",
    transform: "translate(-242.195 -144.708)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M284.9,149.542a1.339,1.339,0,0,1-.484.256,2.031,2.031,0,0,1-.6.089,1.581,1.581,0,0,1-1.154-.4,1.53,1.53,0,0,1-.409-1.145v-2.709h-.838V144.9h.838v-1.08h.893v1.08h1.415v.735h-1.415V148.3a.864.864,0,0,0,.2.614.745.745,0,0,0,.573.214,1.075,1.075,0,0,0,.7-.233Z",
    transform: "translate(-250.944 -142.923)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M306.788,146.762l-1.843,4.933h-.856l-1.424-3.742-1.443,3.742h-.856l-1.834-4.933h.847l1.433,3.928,1.49-3.928h.754l1.462,3.947,1.471-3.947Z",
    transform: "translate(-261.783 -144.788)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M327.644,143.85a2.142,2.142,0,0,1,.554,1.6v2.839H327.3v-2.737a1.513,1.513,0,0,0-.345-1.08,1.293,1.293,0,0,0-.986-.363,1.537,1.537,0,0,0-1.145.424,1.656,1.656,0,0,0-.419,1.215v2.541h-.894v-6.907h.894v2.671a1.843,1.843,0,0,1,.731-.549,2.512,2.512,0,0,1,1.01-.2A2.04,2.04,0,0,1,327.644,143.85Z",
    transform: "translate(-277.607 -141.378)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M343.514,147.138a1.942,1.942,0,0,1,.544,1.5v2.979h-.847v-.652a1.411,1.411,0,0,1-.638.526,2.44,2.44,0,0,1-.982.182,2.053,2.053,0,0,1-1.326-.4,1.376,1.376,0,0,1-.023-2.1,2.337,2.337,0,0,1,1.508-.4h1.415V148.6a1.14,1.14,0,0,0-.335-.884,1.414,1.414,0,0,0-.987-.307,2.609,2.609,0,0,0-.857.144,2.215,2.215,0,0,0-.707.386l-.372-.67a2.693,2.693,0,0,1,.912-.47,3.805,3.805,0,0,1,1.126-.163A2.231,2.231,0,0,1,343.514,147.138Zm-.889,3.616a1.3,1.3,0,0,0,.54-.647v-.688h-1.378q-1.136,0-1.136.763a.69.69,0,0,0,.289.586,1.319,1.319,0,0,0,.8.214A1.655,1.655,0,0,0,342.624,150.753Z",
    transform: "translate(-287.901 -144.708)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M357.542,149.542a1.338,1.338,0,0,1-.484.256,2.031,2.031,0,0,1-.6.089,1.579,1.579,0,0,1-1.154-.4,1.529,1.529,0,0,1-.409-1.145v-2.709h-.838V144.9h.838v-1.08h.893v1.08h1.415v.735h-1.415V148.3a.866.866,0,0,0,.2.614.745.745,0,0,0,.573.214,1.075,1.075,0,0,0,.7-.233Z",
    transform: "translate(-296.954 -142.923)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M380.979,147.175a2.161,2.161,0,0,1,.544,1.6v2.839h-.893v-2.737a1.555,1.555,0,0,0-.331-1.08,1.212,1.212,0,0,0-.945-.363,1.413,1.413,0,0,0-1.08.424,1.7,1.7,0,0,0-.4,1.215v2.541h-.893v-2.737a1.555,1.555,0,0,0-.331-1.08,1.212,1.212,0,0,0-.945-.363,1.415,1.415,0,0,0-1.08.424,1.7,1.7,0,0,0-.4,1.215v2.541h-.894v-4.933h.856v.735a1.732,1.732,0,0,1,.708-.582,2.373,2.373,0,0,1,1-.2,2.184,2.184,0,0,1,1.024.232,1.62,1.62,0,0,1,.689.68,1.893,1.893,0,0,1,.777-.67,2.532,2.532,0,0,1,1.121-.242A2,2,0,0,1,380.979,147.175Z",
    transform: "translate(-309.16 -144.708)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M402.876,147.138a1.941,1.941,0,0,1,.544,1.5v2.979h-.847v-.652a1.411,1.411,0,0,1-.638.526,2.439,2.439,0,0,1-.982.182,2.053,2.053,0,0,1-1.326-.4,1.376,1.376,0,0,1-.023-2.1,2.338,2.338,0,0,1,1.508-.4h1.414V148.6a1.138,1.138,0,0,0-.335-.884,1.414,1.414,0,0,0-.987-.307,2.608,2.608,0,0,0-.856.144,2.21,2.21,0,0,0-.707.386l-.372-.67a2.7,2.7,0,0,1,.912-.47,3.809,3.809,0,0,1,1.127-.163A2.231,2.231,0,0,1,402.876,147.138Zm-.889,3.616a1.3,1.3,0,0,0,.54-.647v-.688h-1.377q-1.136,0-1.136.763a.69.69,0,0,0,.289.586,1.318,1.318,0,0,0,.8.214A1.656,1.656,0,0,0,401.987,150.753Z",
    transform: "translate(-325.5 -144.708)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M416.905,149.542a1.339,1.339,0,0,1-.484.256,2.034,2.034,0,0,1-.6.089,1.581,1.581,0,0,1-1.154-.4,1.528,1.528,0,0,1-.409-1.145v-2.709h-.838V144.9h.838v-1.08h.893v1.08h1.415v.735h-1.415V148.3a.865.865,0,0,0,.2.614.744.744,0,0,0,.572.214,1.075,1.075,0,0,0,.7-.233Z",
    transform: "translate(-334.554 -142.923)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M427.416,149.542a1.339,1.339,0,0,1-.484.256,2.031,2.031,0,0,1-.6.089,1.58,1.58,0,0,1-1.154-.4,1.528,1.528,0,0,1-.41-1.145v-2.709h-.838V144.9h.838v-1.08h.893v1.08h1.415v.735h-1.415V148.3a.866.866,0,0,0,.2.614.745.745,0,0,0,.573.214,1.076,1.076,0,0,0,.7-.233Z",
    transform: "translate(-341.212 -142.923)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M440.028,149.446h-4a1.551,1.551,0,0,0,.573,1.048,1.87,1.87,0,0,0,1.215.4,1.83,1.83,0,0,0,1.424-.6l.493.577a2.153,2.153,0,0,1-.833.6,3.138,3.138,0,0,1-2.5-.116,2.291,2.291,0,0,1-.936-.9,2.576,2.576,0,0,1-.331-1.3,2.612,2.612,0,0,1,.322-1.294,2.3,2.3,0,0,1,.884-.9,2.518,2.518,0,0,1,1.27-.321,2.469,2.469,0,0,1,1.262.321,2.261,2.261,0,0,1,.866.9,2.739,2.739,0,0,1,.312,1.322A2.535,2.535,0,0,1,440.028,149.446Zm-3.5-1.666a1.574,1.574,0,0,0-.507,1.024h3.165a1.589,1.589,0,0,0-.507-1.019,1.666,1.666,0,0,0-2.15,0Z",
    transform: "translate(-348.304 -144.708)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M453.461,146.858a2.5,2.5,0,0,1,1.108-.223v.866a1.653,1.653,0,0,0-.2-.01,1.5,1.5,0,0,0-1.14.433,1.713,1.713,0,0,0-.414,1.233v2.458h-.894v-4.933h.856v.829A1.523,1.523,0,0,1,453.461,146.858Z",
    transform: "translate(-358.935 -144.708)",
    fill: "#0079fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M461.5,151.508a2.553,2.553,0,0,1-.875-.414l.372-.708a2.667,2.667,0,0,0,.791.372,3.255,3.255,0,0,0,.94.139q1.172,0,1.173-.67a.433.433,0,0,0-.158-.353,1,1,0,0,0-.4-.191q-.237-.06-.675-.135a6.653,6.653,0,0,1-.973-.214,1.5,1.5,0,0,1-.647-.41,1.138,1.138,0,0,1-.27-.81,1.264,1.264,0,0,1,.559-1.075,2.5,2.5,0,0,1,1.5-.4,4.129,4.129,0,0,1,.987.121,2.667,2.667,0,0,1,.81.326l-.382.708a2.563,2.563,0,0,0-1.424-.391,1.646,1.646,0,0,0-.866.186.562.562,0,0,0-.3.493.472.472,0,0,0,.167.382,1.069,1.069,0,0,0,.414.2q.247.065.694.148a7.625,7.625,0,0,1,.963.219,1.445,1.445,0,0,1,.628.4,1.1,1.1,0,0,1,.261.782,1.233,1.233,0,0,1-.573,1.066,2.7,2.7,0,0,1-1.559.4A4.123,4.123,0,0,1,461.5,151.508Z",
    transform: "translate(-364.451 -144.708)",
    fill: "#0079fb"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2d0fd5b5ff5252b3495486b969d819b1.svg";
export { ForwardRef as ReactComponent };